module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"mergeFieldDropdown":{"categoryTitle":"Merge fields","error":{"mergeFieldLoad":"There was a problem loading merge fields. Please try again."}}}}')
  delete Component.options._Ctor
}
